export default {
  wrapper: {
    display: 'flex',
    marginBottom: '8px',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
  },
}
